<template>
  <div v-if="loggedInUser.attendant_id == undefined && !loggedInUser.onboarding">
    <nuxt-child />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  layout: 'dashboard',
  computed: {
    ...mapGetters(['loggedInUser'])
  },
  mounted() {
    if (this.loggedInUser.onboarding) {
      this.$router.push({
        name: 'onboarding'
      })
    }
  }
}
</script>
